var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("a-result", {
    attrs: {
      status: "404",
      title: "404",
      "sub-title": "对不起，您访问的页面不存在..."
    },
    scopedSlots: _vm._u([{
      key: "extra",
      fn: function () {
        return [_c("a-button", {
          attrs: {
            type: "primary"
          },
          on: {
            click: _vm.handleBackHome
          }
        }, [_vm._v(" 返回首页 ")])];
      },
      proxy: true
    }])
  });
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };